import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";

import bannerBg from "../../img/accounts/banner-bg.webp";
import oceanMob from "../../img/accounts/banner-ocean-mob.webp";
import iceDollar from "../../img/accounts/ice-dollar.webp";
import iceBtc from "../../img/accounts/ice-btc.webp";

const BTN_GRADIENT_LIGHT =
  "linear-gradient(-84deg, rgba(14,28,54,0.4) 6%, rgba(3,65,180,0.4) 66%)";

function Banner() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="relative overflow-hidden bg-white mt-[55px] lg:mt-[70px]">
      {/* ── Desktop ── */}
      <div className="hidden lg:block relative h-[500px] overflow-hidden">
        <img
          src={bannerBg}
          alt=""
          aria-hidden
          className="hero-a-fade absolute inset-0 w-full h-full object-cover object-bottom pointer-events-none select-none"
        />

        <div className="relative h-full flex flex-col items-center text-center pt-[60px]">
          <h1 className="hero-a-up font-['Inter'] font-black text-[72px] leading-[1.3] text-[#1c385f]">
            {t("accountsPage.banner.title1")}
          </h1>
          <p
            className="hero-a-up mt-[4px] font-['Inter'] font-black text-[42px] leading-[1.3] text-[#1c385f]"
            style={{ animationDelay: ".12s" }}
          >
            {t("accountsPage.banner.title2")}
          </p>
          <p
            className="hero-a-up mt-[25px] font-['Inter'] font-normal text-[16px] leading-[1.5] text-[#1c385f] max-w-[434px]"
            style={{ animationDelay: ".24s" }}
          >
            {t("accountsPage.banner.subtitle")}
          </p>
          <a
            href={link}
            className="hero-a-up hero-cta mt-[40px] inline-flex items-center justify-center px-[42px] py-[18px] rounded-[40px] border border-white font-['Inter'] font-bold text-[21px] text-white capitalize backdrop-blur-[15px] hover:opacity-90 transition-opacity"
            style={{ animationDelay: ".36s", backgroundImage: BTN_GRADIENT_LIGHT }}
          >
            {t("accountsPage.banner.cta")}
          </a>
        </div>
      </div>

      {/* ── Mobile / tablet ── */}
      <div className="lg:hidden relative h-[632px] overflow-hidden">
        <img
          src={oceanMob}
          alt=""
          aria-hidden
          className="hero-a-fade absolute inset-0 w-full h-full object-cover pointer-events-none select-none"
        />

        {/* Льдины: всплывают и покачиваются на воде (ватерлиния фона — 470px) */}
        <img
          src={iceDollar}
          alt=""
          aria-hidden
          className="ice-a absolute left-[10px] top-[333px] w-[200px] max-w-none pointer-events-none select-none"
          style={{
            "--ice-delay": "0.1s",
            "--ice-idle-delay": "1.1s",
            "--ice-dur": "7s",
            "--ice-dist": "36px",
            "--ice-bob": "9px",
            "--ice-rot": "1.2deg",
          }}
        />
        <img
          src={iceBtc}
          alt=""
          aria-hidden
          className="ice-a absolute right-[-10px] top-[354px] w-[260px] max-w-none pointer-events-none select-none"
          style={{
            "--ice-delay": "0.25s",
            "--ice-idle-delay": "1.25s",
            "--ice-dur": "7.8s",
            "--ice-dist": "44px",
            "--ice-bob": "11px",
            "--ice-rot": "-1.4deg",
          }}
        />

        <div className="relative flex flex-col items-center text-center pt-[25px] px-[18px]">
          <h1 className="hero-a-up font-['Inter'] font-black text-[40px] leading-[1.3] text-[#1c385f]">
            {t("accountsPage.banner.title1")}
          </h1>
          <p
            className="hero-a-up font-['Inter'] font-black text-[23px] leading-[1.3] text-[#1c385f]"
            style={{ animationDelay: ".12s" }}
          >
            {t("accountsPage.banner.title2")}
          </p>
          <p
            className="hero-a-up mt-[12px] font-['Inter'] font-normal text-[14px] leading-[1.5] text-[#1c385f] max-w-[320px]"
            style={{ animationDelay: ".24s" }}
          >
            {t("accountsPage.banner.subtitle")}
          </p>
          <a
            href={link}
            className="hero-a-up hero-cta mt-[35px] inline-flex items-center justify-center px-[28px] py-[12px] rounded-[26px] border border-white font-['Inter'] font-bold text-[14px] text-white capitalize backdrop-blur-[10px]"
            style={{ animationDelay: ".36s", backgroundImage: BTN_GRADIENT_LIGHT }}
          >
            {t("accountsPage.banner.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}

export default Banner;
